// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dy-j";
export var fulfillmentFormRail = "_dy-i";
export var headerTitleRow = "_dy-l";
export var orderDetailsWrapper = "_dy-g";
export var orderLinkTrigger = "_dy-2";
export var paymentInformationGrid = "_dy-q";
export var paymentSummaryColumn = "_dy-r";
export var phoneShipmentPickerButton = "_dy-e";
export var phoneShipmentPickerButtonContent = "_dy-f";
export var phoneShipmentPickerButtonWrapper = "_dy-d";
export var phoneShipmentPickerTrigger = "_dy-c";
export var shipmentContainer = "_dy-k";
export var shipmentDetailsMainPane = "_dy-h";
export var shipmentNavigationCard = "_dy-a";
export var shipmentNavigationEdgeTrigger = "_dy-6";
export var shipmentNavigationRail = "_dy-3";
export var shipmentNavigationRailEnter = "_dy-5";
export var shipmentNavigationRailHeader = "_dy-9";
export var shipmentNavigationRailOverlay = "_dy-4";
export var shipmentNavigationScrim = "_dy-7";
export var shipmentSummaryFact = "_dy-n";
export var shipmentSummaryGrid = "_dy-m";
export var shipmentSummaryMetadataRow = "_dy-o";
export var shipmentSummaryTags = "_dy-p";
export var shipmentWorkspace = "_dy-0";
export var shipmentWorkspaceBodyTablet = "_dy-8";
export var shipmentWorkspaceContent = "_dy-b";
export var shipmentWorkspaceHeader = "_dy-1";